module.exports = __webpack_public_path__ + "img/other-service-hotels.24fd9a3c.jpg";